import { useAppStateRaw } from '@/shared/stores/app-store/app-store';

export const insertNewLink = (oldGameUrl: string = '') => {
  const newGameUrl = prompt('paste the link to the game or click cancel') ?? oldGameUrl;

  useAppStateRaw.setState({ gameUrl: newGameUrl });
};
